/** UI strings: key = Bahasa Melayu text. Generated from the key list (scripts/i18n-keys.mjs). */
export const ZH: Record<string, string> = {
  "(pilih 1)": "（选1题）",
  "(sehingga {date})": "（至 {date}）",
  "1 kredit = 1 kertas soalan yang dijana. Kertas yang gagal dijana, JomBelajar dan muat turun semula PDF tidak ditolak.": "1 积分 = 1 份生成的试卷。生成失败、JomBelajar 及重新下载 PDF 均不扣除。",
  "10 soalan daripada unit ini. Jawapan terus disemak.": "本单元的10道题。答案即时批改。",
  "100 pembeli pertama": "首100位买家",
  "60 saat. Berapa banyak yang anda boleh?": "60秒，你能答对多少？",
  "AI sedang menulis dan menyemak soalan. Ini boleh ambil sehingga 1–2 minit.": "AI 正在编写并检查题目，约需1–2分钟。",
  "AI sedang menulis set penuh dan menyemaknya. Ini boleh ambil 2–5 minit.": "AI 正在编写整套试卷并检查，约需2–5分钟。",
  "AI tidak lulus semakan automatik. Cuba lagi atau kurangkan SP.": "AI 生成内容未通过自动检查。请重试或减少学习标准。",
  "AI tidak lulus semakan automatik. Cuba lagi atau kurangkan topik.": "AI 生成内容未通过自动检查。请重试或减少主题。",
  "Adakah jawapan ini betul? Jawab sebanyak mungkin dalam 60 saat!": "这个答案对吗？在60秒内尽量多答！",
  "Affiliate": "推广联盟",
  "Akan datang": "即将推出",
  "Log keluar": "退出登录",
  "Akaun": "账户",
  "Akaun bank disimpan.": "银行账户已保存。",
  "Akaun bank untuk bayaran": "收款银行账户",
  "Akaun ini sudah mempunyai lesen.": "此账户已有许可证。",
  "Akses semua modul": "使用所有模块",
  "Aktifkan lesen": "激活许可证",
  "Aktifkan lesen saya": "激活我的许可证",
  "Anda dapat RM10 setiap kali": "每次可得 RM10",
  "Anda dapat {a} (pembeli RM69) / {b} (pembeli RM79)": "您可得 {a}（RM69买家）/ {b}（RM79买家）",
  "Anda layak jadi affiliate": "您符合成为推广伙伴的资格",
  "Anda sudah ada permintaan bayaran yang belum selesai.": "您已有一项未完成的提款申请。",
  "Anda tiada akses.": "您没有访问权限。",
  "BM & BI: Kertas 1 Pemahaman + Kertas 2 Penulisan": "国文与英文：试卷1 理解 + 试卷2 写作",
  "Baca jarum jam dan pilih waktu yang betul.": "看指针，选出正确的时间。",
  "Baca jarum jam dan pilih waktunya.": "看时钟，选出时间。",
  "Susunan bahagian mengikut subjek · aras rendah:sederhana:tinggi = 5:3:2": "各部分按科目格式编排 · 易:中:难 = 5:3:2",
  "Bahasa Arab": "阿拉伯文",
  "Bahasa Cina": "华文",
  "Bahasa Inggeris": "英文",
  "Bahasa Melayu": "国文",
  "Bahasa Tamil": "淡米尔文",
  "Bahasa kertas": "试卷语言",
  "Baki belum cukup minimum pengeluaran.": "余额未达最低提款额。",
  "Baki boleh dikeluarkan": "可提款余额",
  "Baki boleh dikeluarkan {amount}. Minimum pengeluaran {min}.": "可提款余额 {amount}。最低提款额为 {min}。",
  "Baki kertas AI": "剩余 AI 试卷",
  "Bank / e-wallet": "银行 / 电子钱包",
  "Batal": "取消",
  "Bayar": "付款",
  "Bayar harga barang dengan tepat. Tekan syiling dan wang kertas, kemudian tekan Bayar.": "准确支付商品价格。点击硬币和纸币，然后点击“付款”。",
  "Bayar harga dengan syiling dan wang kertas.": "用硬币和纸币付款。",
  "Bayar kepada {name} jumlah tepat:": "请向 {name} 支付以下准确金额：",
  "Bayar melalui DuitNow QR.": "使用 DuitNow QR 付款。",
  "Bayar sekali, guna selamanya": "一次付款，终身使用",
  "Bayaran": "付款",
  "Bayaran belum disahkan.": "付款尚未确认。",
  "Bayaran disahkan": "付款已确认",
  "Bayaran diterima untuk semakan. Kredit akan ditambah selepas disahkan.": "付款已提交审核。确认后将添加积分。",
  "Pembayaran dalam talian tidak tersedia buat masa ini. Sila cuba lagi sebentar nanti.": "在线支付暂时不可用，请稍后再试。",
  "Bayaran tidak dapat disahkan": "无法确认付款",
  "Belajar Lebih Bijak Bersama JomCerdik": "与 JomCerdik 一起聪明学习",
  "Belajar sambil bermain. Setiap permainan dikira dalam kemajuan anda.": "边玩边学，每个游戏都计入您的进度。",
  "Beli JomCerdik Lifetime": "购买 JomCerdik 终身版",
  "Beli sekarang": "立即购买",
  "Belum ada jualan. Kongsi link anda di WhatsApp, Telegram atau Facebook.": "还没有销售。请在 WhatsApp、Telegram 或 Facebook 分享您的链接。",
  "Belum ada kertas.": "还没有试卷。",
  "Berapa bahagian pizza yang ada pepperoni? Pilih pecahan yang betul.": "有多少比萨上有香肠片？选出正确的分数。",
  "Berapa pecahan berlorek? (bentuk termudah)": "涂色部分是几分之几？（最简分数）",
  "Berapa pecahan pizza yang berlorek merah?": "比萨的红色部分是几分之几？",
  "Betul": "对",
  "Betul atau Salah Kilat": "对错快答",
  "Betul!": "答对了！",
  "Betul! Laju!": "答对了！真快！⚡",
  "Bilangan soalan: {n}": "题目数量：{n}",
  "Buat pesanan baharu": "重新下单",
  "Ciri ini untuk pemegang lesen.": "此功能仅限许可证持有者。",
  "Contoh": "例子",
  "Cuba lagi": "再试一次",
  "Cuba lagi. Anda pasti boleh!": "再试一次，你一定行！",
  "Cuba lagi. Baca semula nota dan jawab sekali lagi.": "再试一次。重读笔记后再作答。",
  "DSKP ({n} soalan)": "DSKP（{n} 题）",
  "Dapatkan lesen": "获取许可证",
  "Dapatkan link affiliate saya": "获取我的推广链接",
  "Dasar Privasi": "隐私政策",
  "Data DSKP sedang dimuatkan ke sistem. Cuba lagi sebentar lagi.": "DSKP 数据正在载入系统，请稍后再试。",
  "Dibatalkan (refund)": "已取消（退款）",
  "Dibayar": "已付款",
  "Diluluskan": "已批准",
  "Diminta": "已申请",
  "Disalin ✓": "已复制 ✓",
  "Ditolak": "已拒绝",
  "Dokumen undang-undang ini dalam Bahasa Melayu. Versi Bahasa Melayu ialah rujukan rasmi.": "本法律文件以马来文撰写，马来文版本为正式依据。",
  "Duit anda": "你的钱",
  "Early Bird (100 terawal)": "早鸟价（首100位）",
  "Early Bird 2 (pembeli 101–200)": "早鸟价2（第101–200位）",
  "Emel": "电邮",
  "Emel tidak sah.": "电邮无效。",
  "Faham! Seterusnya →": "明白了！下一个 →",
  "Faham! ✔": "明白了！✔",
  "Fail terlalu besar. Maksimum 5 MB.": "文件太大，最大 5 MB。",
  "Format UASA": "UASA 格式",
  "Format UASA (lama)": "UASA 格式（旧）",
  "Format kertas tidak dijumpai.": "找不到试卷格式。",
  "Fungsi ini sedang dibina (Fasa {phase}). Tiada data dipaparkan sehingga ia disambungkan ke sistem sebenar.": "此功能正在开发中（第 {phase} 阶段）。连接正式系统前不会显示数据。",
  "Gambar atau PDF (maksimum 5 MB). Invois diemel selepas bayaran disahkan.": "图片或 PDF（最大 5 MB）。付款确认后将电邮发票。",
  "Gambar atau PDF resit DuitNow / bank (maksimum 5 MB). Invois rasmi akan diemel selepas bayaran disahkan.": "DuitNow / 银行收据的图片或 PDF（最大 5 MB）。付款确认后将电邮正式发票。",
  "Geografi": "地理",
  "Habis": "已售罄",
  "Had penjanaan dicapai. Kertas lama masih boleh dimuat turun.": "已达生成上限。旧试卷仍可下载。",
  "Halaman tidak dijumpai": "找不到页面",
  "Hampir habis!": "快用完了！",
  "Hantar": "提交",
  "Hantar pautan": "发送链接",
  "Harga": "价格",
  "Harga awal untuk pembeli terawal": "早期买家优惠价",
  "Harga biasa": "标准价",
  "Harga biasa selepas itu": "之后恢复标准价",
  "Harga {p1} dan {p2} hanya untuk pembelian terus di sini. Hanya 200 pembeli awal boleh menjadi affiliate: rakan anda beli pada {p3}, dan anda dapat {c1} (jika anda beli {p1}) atau {c2} (jika anda beli {p2}) bagi setiap jualan.": "{p1} 和 {p2} 的价格仅限在此直接购买。只有首200位买家可成为推广伙伴：朋友以 {p3} 购买，每笔销售您可得 {c1}（若您以 {p1} 购买）或 {c2}（若您以 {p2} 购买）。",
  "Harga {price} + {sen} sen kod padanan.": "价格 {price} + {sen} 仙配对码。",
  "Hebat! Teruskan usaha.": "太棒了！继续加油。",
  "Ikut DSKP": "依据 DSKP",
  "Imbas & bayar": "扫码付款",
  "Itu sebenarnya betul!": "那其实是对的！",
  "Jam Ajaib": "神奇时钟",
  "Jam analog": "指针时钟",
  "Jana kertas": "生成试卷",
  "Jana set soalan": "生成整套试题",
  "Jawab betul untuk melompat ke batu seterusnya. Sampai ke istana sebelum nyawa habis!": "答对就能跳到下一块石头。在生命用完前到达城堡！",
  "Jawab betul untuk sampai ke istana.": "答对题目，到达城堡。",
  "Jawapan betul: {x}": "正确答案：{x}",
  "Jawapan: ": "答案：",
  "Jenis": "类型",
  "Jom belajar hari ini!": "今天一起学习吧！",
  "Jom guna JomCerdik — nota, kuiz dan kertas latihan ikut DSKP untuk anak-anak. Daftar di sini: {link}": "一起用 JomCerdik —— 依据 DSKP 的笔记、测验和练习卷，适合孩子使用。在此注册：{link}",
  "JomBelajar untuk pemegang lesen JomCerdik.": "JomBelajar 仅供 JomCerdik 许可证持有者使用。",
  "Jualan lesen": "许可证销售",
  "Jumlah": "金额",
  "Jumlah perlu dibayar (tepat)": "应付金额（准确）",
  "KBAT": "高阶思维",
  "Kad tertutup": "未翻开的卡",
  "Kami akan hantar pautan log masuk ke emel anda. Tiada kata laluan.": "我们会把登录链接发送到您的电邮，无需密码。",
  "Kami tidak menjumpai bayaran yang sepadan. Hubungi kami dengan kod rujukan dan bukti bayaran.": "我们找不到相符的付款。请附上参考编号和付款证明联系我们。",
  "Kandungan sedang disediakan": "内容准备中",
  "Ke laman utama": "前往首页",
  "Ke nota": "查看笔记",
  "Kedai Wang": "金钱商店",
  "Keluarkan duit": "提款",
  "Keluarkan {amount}": "提取 {amount}",
  "Keluarkan {amount} ke {bank} {acc} ({holder})?": "提取 {amount} 至 {bank} {acc}（{holder}）？",
  "Kembali": "返回",
  "Kembali ke laman utama": "返回首页",
  "Kertas": "试卷",
  "Kertas 1": "试卷1",
  "Kertas 1 - Pemahaman": "试卷1 - 理解",
  "Kertas 2 - Penulisan": "试卷2 - 写作",
  "Kertas AI": "AI 试卷",
  "Kertas AI anda sudah habis.": "您的 AI 试卷已用完。",
  "Kertas dan skema jawapan": "试卷和答案",
  "Kertas saya": "我的试卷",
  "Kertas siap! Muat turun di senarai 'Kertas saya'.": "试卷已完成！请在“我的试卷”中下载。",
  "Kertas soalan": "试卷",
  "Kertas {n}": "试卷{n}",
  "Kod": "代码",
  "Kod dan huraian SP diambil terus daripada dokumen rasmi DSKP.": "学习标准代码和描述直接取自 DSKP 官方文件。",
  "Kod referral: {code}": "推荐码：{code}",
  "Komisen anda: {amount} setiap jualan lesen + RM10 setiap topup pelanggan.": "您的佣金：每笔许可证销售 {amount} + 每次客户充值 RM10。",
  "Komisen terkini": "最新佣金",
  "Kongsi di WhatsApp": "分享到 WhatsApp",
  "Kongsi link anda. Dapat komisen setiap jualan lesen dan setiap kali pelanggan anda tambah kredit.": "分享您的链接。每笔许可证销售以及客户每次充值积分，您都能获得佣金。",
  "Kredit AI anda sudah habis. Tambah kredit di halaman Kredit untuk menjana lagi.": "您的 AI 积分已用完。请到积分页面充值以继续生成。",
  "Kredit AI datang bersama lesen.": "AI 积分随许可证附送。",
  "Kredit lesen": "许可证积分",
  "Kuiz dijawab": "已答测验",
  "Kuiz terbaik": "最佳测验",
  "Kurang {x}.": "还差 {x}。",
  "Laman utama": "首页",
  "Latihan ({n} soalan)": "练习（{n} 题）",
  "Latihan ikut DSKP": "DSKP 练习",
  "Latihan mengikut format UASA": "按 UASA 格式练习",
  "Lesen": "许可证",
  "Lesen akan diikat pada emel ini.": "许可证将绑定此电邮。",
  "Lesen lifetime anda kini aktif. Selamat belajar!": "您的终身许可证已激活。学习愉快！",
  "Lihat JomBelajar": "查看 JomBelajar",
  "Lihat penjana": "查看生成器",
  "Lihat resit": "查看收据",
  "Lihat semua": "查看全部",
  "Link affiliate anda": "您的推广链接",
  "Log masuk": "登录",
  "Log masuk dengan emel yang digunakan semasa membeli.": "请使用购买时的电邮登录。",
  "Log masuk dengan emel yang sama digunakan semasa membeli untuk mengaktifkan lesen.": "请使用购买时的同一电邮登录以激活许可证。",
  "Log masuk sebagai {email}.": "已以 {email} 登录。",
  "Log masuk untuk mula belajar.": "登录后开始学习。",
  "Main": "开始玩",
  "Main lagi": "再玩一次",
  "Masih dijana (set penuh ambil 2–5 minit). Anda boleh tinggalkan halaman ini.": "仍在生成中（整套约需2–5分钟）。您可以离开此页面。",
  "Masih dijana. Anda boleh tinggalkan halaman ini; kertas akan muncul dalam senarai.": "仍在生成中。您可以离开此页面，试卷会出现在列表中。",
  "Matematik": "数学",
  "Memuatkan DSKP…": "正在载入 DSKP…",
  "Memuatkan…": "载入中…",
  "Mengesahkan pautan…": "正在验证链接…",
  "Menu": "菜单",
  "Minimum keluar {min} · pindahan bank": "最低提款 {min} · 银行转账",
  "Mudah": "简单",
  "Muka depan, kotak pemeriksa, rajah": "封面、阅卷栏、图表",
  "Mula belajar": "开始学习",
  "Mula kuiz": "开始测验",
  "Mula — semua unit": "开始 — 所有单元",
  "Mula!": "开始！",
  "Nama pembayar (seperti dalam akaun)": "付款人姓名（与账户一致）",
  "Nama pemegang akaun": "账户持有人姓名",
  "No. akaun": "账号",
  "No. rujukan transaksi bank / e-wallet": "银行 / 电子钱包交易参考号",
  "Nota dan kuiz ikut DSKP dan KSSR.": "依据 DSKP 和 KSSR 的笔记与测验。",
  "Nota penting": "重点笔记",
  "Nota, latihan dan kuiz": "笔记、练习与测验",
  "Nyawa: {n}": "生命：{n}",
  "PDF Kertas + Skema": "试卷 + 答案 PDF",
  "PDF tidak dapat dibina untuk kertas ini. Sila laporkan kepada admin.": "无法为此试卷生成 PDF。请向管理员报告。",
  "Padan Kad": "配对卡",
  "Pautan log masuk tidak sah atau sudah tamat.": "登录链接无效或已过期。",
  "Pautan pengaktifan lesen telah dihantar ke {email}. Semak inbox, Spam dan Promosi.": "许可证激活链接已发送至 {email}。请查看收件箱、垃圾邮件和促销文件夹。",
  "Pautan pengaktifan sudah digunakan.": "激活链接已被使用。",
  "Pautan pengaktifan sudah tamat. Hubungi kami untuk pautan baharu.": "激活链接已过期。请联系我们获取新链接。",
  "Pautan pengaktifan tidak lengkap. Buka semula pautan dari emel anda.": "激活链接不完整。请从电邮重新打开链接。",
  "Pautan pengaktifan tidak sah.": "激活链接无效。",
  "Pecahkan belon dengan jawapan yang betul untuk terbangkan roket ke bulan!": "戳破正确答案的气球，让火箭飞上月球！",
  "Pecahkan belon jawapan betul, terbangkan roket!": "戳破正确的气球，发射火箭！",
  "Pelajaran dipelajari": "已学课程",
  "Pelanggan": "客户",
  "Pelanggan anda topup RM50": "您的客户充值 RM50",
  "Pelanggan bayar {price}": "客户支付 {price}",
  "Pelarasan admin": "管理员调整",
  "Pelawat link": "链接访客",
  "Pembeli ke-101 hingga 200": "第101至200位买家",
  "Pendidikan Islam": "伊斯兰教育",
  "Pendidikan Jasmani": "体育",
  "Pendidikan Kesihatan": "健康教育",
  "Pendidikan Moral": "道德教育",
  "Pendidikan Muzik": "音乐",
  "Pendidikan Seni Visual": "美术",
  "Penerima: {name}. Tulis {ref} dalam ruangan rujukan jika app bank anda membenarkan.": "收款人：{name}。若银行应用允许，请在参考栏填写 {ref}。",
  "Pengeluaran {amount} (diminta {date}) sedang diproses. Resit akan diemel kepada anda.": "您于 {date} 申请的 {amount} 提款正在处理中，收据将电邮给您。",
  "Pengembaraan Soalan": "答题大冒险",
  "Penjana Kertas": "试卷生成器",
  "Penjana UASA": "UASA 生成器",
  "Penjana kertas sedang sibuk. Cuba lagi kemudian.": "试卷生成器正忙，请稍后再试。",
  "Penjana kertas untuk pemegang lesen.": "试卷生成器仅供许可证持有者使用。",
  "Penjanaan gagal.": "生成失败。",
  "Perkhidmatan AI tidak dapat dihubungi. Kredit anda tidak ditolak.": "无法连接 AI 服务。您的积分未被扣除。",
  "Tahun 1–3": "一至三年级",
  "Tahun 4–6": "四至六年级",
  "Harga dan pembelian": "价格与购买",
  "Tebus kod": "兑换代码",
  "Permainan dan kuiz": "游戏和测验",
  "Permainan": "游戏",
  "Permainan dimainkan": "已玩游戏",
  "Permainan lain": "其他游戏",
  "Permainan memori: padankan soalan dan jawapan.": "记忆游戏：把题目和答案配对。",
  "Permintaan {amount} dihantar. Anda akan terima emel bersama resit sebaik sahaja duit dipindahkan.": "已提交 {amount} 的提款申请。款项转出后，您将收到附有收据的电邮。",
  "Pesanan ini sudah diproses.": "此订单已处理。",
  "Pesanan ini tamat kerana tiada bayaran direkodkan. Jika anda sudah bayar, hubungi kami dengan kod rujukan ini.": "此订单因未记录付款而过期。若您已付款，请以此参考编号联系我们。",
  "Pesanan tidak dijumpai. Semak kod rujukan dan emel.": "找不到订单。请检查参考编号和电邮。",
  "Pesanan {ref}": "订单 {ref}",
  "Pilih sifir": "选择乘法表",
  "Pilih subjek": "选择科目",
  "Pilih tahun anda": "选择您的年级",
  "Pilih unit dan SP": "选择单元和学习标准",
  "Pizza Pecahan": "分数比萨",
  "Pizza dengan {k} daripada {n} potong berlorek": "{n} 块比萨中有 {k} 块涂色",
  "Polisi Pembatalan & Refund": "取消与退款政策",
  "Polisi Refund": "退款政策",
  "Privasi": "隐私",
  "Program affiliate terbuka kepada 200 pembeli awal (RM69 / RM79) yang lesennya aktif.": "推广计划开放给许可证有效的首200位买家（RM69 / RM79）。",
  "Program akan dibuka kepada pengguna lain melalui promosi akan datang.": "该计划将在未来的促销活动中向其他用户开放。",
  "Pukul berapa?": "现在几点？",
  "Ralat rangkaian. Cuba lagi.": "网络错误，请重试。",
  "Ralat sistem. Kredit anda tidak ditolak.": "系统错误。您的积分未被扣除。",
  "Ralat tidak dijangka. Cuba lagi.": "发生意外错误，请重试。",
  "Reka Bentuk dan Teknologi": "设计与工艺",
  "Resit / screenshot bayaran": "付款收据 / 截图",
  "Resit mesti gambar (JPG/PNG/WEBP) atau PDF.": "收据必须是图片（JPG/PNG/WEBP）或 PDF。",
  "Resit tidak dapat dibuka. Cuba lagi.": "无法打开收据，请重试。",
  "Rujukan bank ini sudah digunakan untuk pesanan lain.": "此银行参考号已用于另一订单。",
  "Rujukan: {ref}": "参考号：{ref}",
  "Sahkan emel anda dahulu.": "请先验证您的电邮。",
  "Sains": "科学",
  "Salah": "错",
  "Salin link": "复制链接",
  "Satu lesen, semua modul, akses seumur hidup.": "一个许可证，所有模块，终身使用。",
  "Satu pautan, satu akaun, sekali guna.": "一个链接，一个账户，仅限使用一次。",
  "Saya bersetuju dengan": "我同意",
  "Saya sudah bayar": "我已付款",
  "Sedang dijana…": "生成中…",
  "Sederhana": "中等",
  "Pengeluaran diproses setiap {n} hari (2 minggu sekali)": "每 {n} 天（两周一次）处理提款",
  "Pengeluaran dibayar setiap 2 minggu sekali. Permohonan dibayar pada pusingan seterusnya.": "每两周结算一次提款。申请将在下一轮支付。",
  "Sedia dikeluarkan": "可提款",
  "Sedia untuk kuiz?": "准备好测验了吗？",
  "Sejarah": "历史",
  "Sejarah kredit": "积分记录",
  "Selesai": "完成",
  "Semak emel anda. Pautan sah selama 15 minit. Log masuk di peranti baharu akan menamatkan sesi lama.": "请查看电邮。链接有效15分钟。在新设备登录将结束旧的登录。",
  "Semakan jawapan": "答案检查",
  "Semua subjek": "所有科目",
  "Semua subjek · Tahun 1–6": "所有科目 · 一至六年级",
  "Set format UASA": "UASA 格式试卷",
  "Set soalan format UASA": "UASA 格式试题",
  "Set soalan format UASA untuk semua subjek Tahun 1–6, atau latihan ikut DSKP.": "一至六年级所有科目的 UASA 格式试题，或依据 DSKP 的练习。",
  "Seterusnya": "下一题",
  "Sifir Roket": "乘法火箭",
  "Sila lampirkan resit atau screenshot bayaran.": "请附上付款收据或截图。",
  "Sila log masuk.": "请登录。",
  "Sila semak maklumat yang dimasukkan.": "请检查您输入的资料。",
  "Sila tunggu…": "请稍候…",
  "Simpan akaun bank": "保存银行账户",
  "Simpan akaun bank anda dahulu.": "请先保存您的银行账户。",
  "Simpan akaun bank anda di atas dahulu.": "请先在上方保存您的银行账户。",
  "Skema jawapan": "答案",
  "Skema jawapan berasingan": "答案另附",
  "Slot Early Bird anda disimpan selama {time} lagi.": "您的早鸟名额将再保留 {time}。",
  "Slot Early Bird pesanan ini telah dilepaskan.": "此订单的早鸟名额已释放。",
  "Soalan ditanda dengan kod SP": "题目附学习标准代码",
  "Soalan {i} daripada {n}": "第 {i} 题 / 共 {n} 题",
  "Standard": "标准",
  "Standard Pembelajaran (DSKP)": "学习标准（DSKP）",
  "Standard Pembelajaran ({n}/{max} dipilih)": "学习标准（已选 {n}/{max}）",
  "Status": "状态",
  "Subjek": "科目",
  "Sudah bayar?": "已付款？",
  "Sudah dibayar": "已付款",
  "Tahap": "级别",
  "Tahun": "年级",
  "Tahun / Tingkatan": "年级 / 中学级别",
  "Tahun 1 hingga 6": "一至六年级",
  "Tahun {n}": "{n}年级",
  "Tambah kertas": "增加试卷",
  "Tambah kredit": "充值积分",
  "Tambah {n} kertas dengan {price}.": "以 {price} 增加 {n} 份试卷。",
  "Tambah {n} kertas — {price}": "增加 {n} 份试卷 — {price}",
  "Tanpa had": "无限",
  "Tarikh": "日期",
  "Teka pecahan pizza yang berlorek.": "猜猜比萨涂色部分的分数。",
  "Tekan duit di bawah untuk bayar.": "点击下面的钱来付款。",
  "Tempoh pesanan tamat": "订单已过期",
  "Tempoh pesanan telah tamat. Sila buat pesanan baharu.": "订单已过期，请重新下单。",
  "Tempoh simpanan tamat. Jika anda sudah bayar, hantar rujukan sekarang.": "保留时间已过。若您已付款，请立即提交参考号。",
  "Terbalikkan dua kad. Padankan setiap soalan (biru) dengan jawapannya (kuning).": "翻开两张卡，把每道题（蓝色）和答案（黄色）配对。",
  "Terima kasih! Bayaran anda sedang disemak. Pautan pengaktifan akan dihantar ke {email} sebaik sahaja disahkan (biasanya dalam masa beberapa jam pada waktu bekerja). Halaman ini dikemas kini secara automatik. Emel kadang-kadang masuk ke folder Spam atau Promosi, jadi sila semak di situ juga.": "谢谢！您的付款正在审核中。确认后激活链接将发送至 {email}（通常在工作时间内数小时）。本页会自动更新。邮件有时会进入垃圾邮件或促销文件夹，请也到那里查看。",
  "Terima kasih! Kredit akan ditambah sebaik sahaja bayaran disahkan (biasanya dalam hari yang sama).": "谢谢！付款确认后将立即添加积分（通常在当天）。",
  "Terlalu banyak cubaan. Cuba lagi sebentar.": "尝试次数过多，请稍后再试。",
  "Terlalu ramai sedang membuat bayaran. Cuba lagi dalam beberapa minit.": "目前付款人数过多，请几分钟后再试。",
  "Terlebih {x}. Cuba kira semula.": "多了 {x}，再数一数。",
  "Terma": "条款",
  "Terma & Syarat": "条款与条件",
  "Tertahan": "暂扣中",
  "Tertahan {n} hari (tempoh refund)": "暂扣 {n} 天（退款期）",
  "Teruskan ke bayaran": "继续付款",
  "Tiada rekod lagi.": "还没有记录。",
  "Tiada soalan untuk pilihan ini lagi.": "此选项暂无题目。",
  "Tiada subjek untuk tahun ini lagi.": "此年级暂无科目。",
  "Tidak dijawab": "未作答",
  "Tinggal {n} slot": "剩余 {n} 个名额",
  "Tingkatan {n}": "中学{n}年级",
  "Topup kredit": "积分充值",
  "Topup pelanggan": "客户充值",
  "Tukar": "更改",
  "Tukar bahasa": "切换语言",
  "Tukar ke tema cerah": "切换到浅色主题",
  "Tukar ke tema gelap": "切换到深色主题",
  "Tutup": "关闭",
  "UASA, nota, kuiz dan PDF dalam satu platform.": "UASA、笔记、测验和 PDF，尽在一个平台。",
  "Unit": "单元",
  "Unit yang diuji ({n}/{max})": "测试单元（{n}/{max}）",
  "Utama": "主菜单",
  "Utama (mudah alih)": "主菜单（手机）",
  "Versi": "版本",
  "Waktu pagi. Apakah waktu dalam sistem 24 jam?": "早上。用24小时制是几点？",
  "Waktu petang/malam. Apakah waktu dalam sistem 24 jam?": "下午/晚上。用24小时制是几点？",
  "atau pilih satu unit": "或选择一个单元",
  "dan": "和",
  "dwibahasa": "双语",
  "isian": "填空",
  "padanan": "配对",
  "tanda ✓/×": "打勾/打叉",
  "jawapan pendek": "简答",
  "kertas": "份试卷",
  "kertas lagi boleh dijana": "份试卷可生成",
  "objektif": "选择题",
  "pelajaran": "课",
  "pelajaran selesai": "课已完成",
  "rujukan {ref}": "参考号 {ref}",
  "sen": "仙",
  "struktur": "结构题",
  "susun ayat": "排句子",
  "tanpa had": "无限",
  "unit": "单元",
  "unit sedia": "单元已就绪",
  "untuk melihat kredit anda.": "以查看您的积分。",
  "untuk melihat link affiliate anda.": "以查看您的推广链接。",
  "untuk menjana kertas.": "以生成试卷。",
  "versi English": "英文版",
  "{amount} lagi masih tertahan ({n} hari selepas jualan) dan akan masuk ke baki secara automatik.": "另有 {amount} 仍在暂扣中（每笔销售后 {n} 天），之后将自动转入余额。",
  "{a} kumpulan, setiap satu ada {b}": "{a} 组，每组 {b} 个",
  "{m} markah, {d} minit": "{m} 分，{d} 分钟",
  "{n} hari selepas jualan": "销售后 {n} 天",
  "{n} langkah": "{n} 步",
  "{price} untuk {n} kertas. Lesen anda kekal sama.": "{price} 可得 {n} 份试卷。许可证保持不变。",
  "Lapor masalah": "报告问题",
  "Terangkan apa yang berlaku. Halaman semasa dihantar sekali supaya kami boleh semak.": "请描述发生了什么。当前页面会一并发送，方便我们检查。",
  "Contoh: Butang muat turun skema tak jalan untuk Sains Tahun 4.": "例如：四年级科学的答案下载按钮无法使用。",
  "Terima kasih! Laporan anda sudah dihantar.": "谢谢！您的报告已发送。",
  "Laporan tidak dapat dihantar. Cuba lagi.": "报告无法发送，请重试。",
  "Simpan gambar QR": "保存二维码图片",
  "Guna telefon? Simpan gambar QR, kemudian buka app bank atau e-wallet → DuitNow QR → pilih gambar dari galeri.": "使用手机？先保存二维码图片，然后打开银行或电子钱包应用 → DuitNow QR → 从相册选择图片。",
  "Tadika · 4–6 tahun": "幼儿园 · 4–6岁",
  "Jom Baca": "一起读",
  "8 tahap suku kata: dari a-i-u hingga baca cerita.": "8个音节级别：从 a-i-u 到读故事。",
  "Mula": "开始",
  "Tadika: Jom Baca": "幼儿园：一起读",
  "Belajar membaca dengan kaedah suku kata, 8 tahap. Untuk umur 4–6 tahun.": "用音节法学习阅读马来文，共8级。适合4–6岁。",
  "Untuk ibu bapa: duduk bersama anak. Tekan suku kata untuk dengar bunyinya, minta anak sebut semula, kemudian main permainan di setiap tahap.": "家长须知：请陪孩子一起学习。点击音节听发音，让孩子跟读，然后玩每一级的游戏。",
  "Peranti ini tidak menyokong bunyi. Bacakan suku kata untuk anak.": "此设备不支持声音。请为孩子读出音节。",
  "Tahap {n}": "第{n}级",
  "Tahap tidak dijumpai.": "找不到该级别。",
  "Kembali ke tahap": "返回本级",
  "Suku kata": "音节",
  "Perkataan": "词语",
  "Baca ayat": "读句子",
  "Cerita": "故事",
  "Baca dan jawab {n} soalan": "阅读并回答{n}个问题",
  "Jom main": "一起玩",
  "Cantum suku kata": "拼音节",
  "Susun suku kata ikut gambar.": "按图片排列音节。",
  "Pilih gambar": "选图片",
  "Baca perkataan, tekan gambar yang betul.": "读词语，点击正确的图片。",
  "Tahap seterusnya": "下一级",
  "tekan untuk dengar": "点击收听",
  "Dengar ayat": "听句子",
  "Pandai! Teruskan membaca.": "真棒！继续阅读。",
  "Dengar": "听",
  "Tekan gambar untuk dengar perkataan.": "点击图片听词语。",
  "Dengar cerita": "听故事",
  "Jawab soalan": "回答问题",
  "Suara: {name}": "语音：{name}",
  "Uji suara": "测试语音",
  "Telefon ini tiada suara Bahasa Melayu, jadi bunyi dimatikan supaya sebutan tidak salah.": "此手机没有马来语语音，为避免发音错误，声音已关闭。",
  "iPhone/iPad: Settings → Accessibility → Spoken Content → Voices → Malay (atau Indonesian) → muat turun.": "iPhone/iPad：设置 → 辅助功能 → 朗读内容 → 声音 → 马来语（或印尼语）→ 下载。",
  "Android: Settings → Bahasa & input → Output teks-ke-pertuturan → Google → Pasang data suara → Bahasa Melayu (atau Indonesia).": "Android：设置 → 语言和输入 → 文字转语音输出 → Google → 安装语音数据 → 马来语（或印尼语）。",
  "Selepas itu tutup dan buka semula pelayar. Sementara itu, bacakan suku kata untuk anak.": "然后关闭并重新打开浏览器。在此之前，请为孩子读出音节。",
  "Audio sebutan JomCerdik": "JomCerdik 发音音频",
  "Kira Gambar": "数图片",
  "Kira gambar, kemudian tekan jawapan yang betul.": "数一数图片，然后点击正确答案。",
  "Tambah gambar": "图片加法",
  "Kira gambar": "数图片",
  "Tekan gambar untuk mengira: satu, dua, tiga…": "点击图片来数：一、二、三……",
  "Kenal huruf": "认识字母",
  "Huruf apa?": "什么字母？",
  "Cari huruf": "找字母",
  "Celik Jawi": "爪夷文入门",
  "37 huruf Jawi. Tekan huruf untuk dengar namanya.": "37个爪夷文字母。点击字母听名称。",
  "Huruf apakah ini?": "这是什么字母？",
  "Cari huruf ini:": "找出这个字母：",
  "Mewarna": "涂色",
  "Pilih warna, kemudian tekan bahagian gambar.": "选择颜色，然后点击图片的一部分。",
  "Gambar lain": "其他图片",
  "Undur": "撤销",
  "Padam semua": "全部清除",
  "Simpan gambar": "保存图片",
  "Matematik tadika: kira dan tambah.": "幼儿数学：数数和加法。",
  "Kenal huruf Jawi dan bunyinya.": "认识爪夷文字母及其发音。",
  "Pilih warna, tekan gambar.": "选颜色，点图片。",
  "Permainan Tadika": "幼儿游戏",
  "Jom Baca: 8 tahap": "一起读：8个级别",
  "Pentaksiran Tahun 1–3 (PBD) dan set format UASA Tahun 4–6, atau latihan ikut DSKP.": "一至三年级课堂评估（PBD）、四至六年级UASA格式试卷，或根据DSKP进行练习。",
  "Pentaksiran & UASA": "评估与UASA",
  "Tahun 1–3: latihan pentaksiran PBD": "一至三年级：PBD课堂评估练习",
  "Tahun 4–6: set format UASA": "四至六年级：UASA格式试卷",
  "Set latihan pentaksiran Tahun 1–3 (PBD)": "一至三年级课堂评估（PBD）练习卷",
  "Tahun 1–3 menggunakan pentaksiran bilik darjah (PBD), bukan format UASA rasmi KPM. Semak kesesuaian soalan sebelum digunakan.": "一至三年级采用课堂评估（PBD），而非马来西亚教育部官方UASA格式。使用前请检查题目是否合适。",
  // ── Dunia 3D (peta, dunia tahun, aktiviti, demo) ──
  "KECIL LANGKAHNYA. BESAR DUNIANYA.": "脚步虽小，世界很大。",
  "Belajar jadi": "学习变成",
  "satu pengembaraan.": "一场冒险。",
  "Enam dunia untuk diteroka. Seribu sebab untuk rasa ingin tahu.": "六个世界等你探索，千百个理由保持好奇。",
  "Jom teroka": "一起去探索",
  "Latihan UASA": "UASA练习",
  "PILIH PENGEMBARAAN KAMU": "选择你的冒险",
  "Hari ini, ke dunia mana?": "今天去哪个世界？",
  "JomBelajar sebenar →": "正式的 JomBelajar →",
  "Sentuhan portal menggerakkan maskot dan kamera sebelum dunia dibuka.": "点击传送门后，吉祥物和镜头会先移动，然后世界才会打开。",
  "Istana Ajaib": "魔法城堡",
  "Langkah pertama, penemuan besar.": "第一步，大发现。",
  "Taman Fantasi": "奇幻花园",
  "Ilmu berkembang di setiap sudut.": "知识在每个角落生长。",
  "Hutan Pengembaraan": "探险森林",
  "Ikuti denai. Temui jawapannya.": "沿着小径，找到答案。",
  "Dunia Angkasa": "太空世界",
  "Bawa rasa ingin tahu ke orbit.": "带着好奇心飞向轨道。",
  "Bandar Ilmu": "知识城",
  "Bina idea, satu demi satu.": "一个接一个，构建想法。",
  "Dunia Futuristik": "未来世界",
  "Bersedia untuk pengembaraan seterusnya.": "为下一场冒险做好准备。",
  "Buku cerita & huruf": "故事书与字母",
  "Words & conversations": "单词与对话",
  "Nombor, bentuk & idea": "数字、形状与想法",
  "Eksperimen & penemuan": "实验与发现",
  "Kisah, peta & garis masa": "故事、地图与时间线",
  "Berapakah 6 + 7?": "6 + 7 等于多少？",
  "Bahagian tumbuhan manakah menyerap air?": "植物的哪一部分吸收水分？",
  "Bilakah Persekutuan Tanah Melayu mencapai kemerdekaan?": "马来亚联合邦何时获得独立？",
  "Bunga": "花",
  "Daun": "叶",
  "Akar": "根",
  "Batang": "茎",
  "Air": "水",
  "Cahaya": "光",
  "Tumbuh": "生长",
  "Kini": "现在",
  "Dunia tidak ditemui": "找不到该世界",
  "Kembali ke peta": "返回地图",
  "← Semua dunia": "← 所有世界",
  "PENGEMBARAAN TAHUN {n}": "{n}年级冒险",
  "Kandungan tahun ini →": "本年级内容 →",
  "Mari teroka {name}.": "一起探索{name}吧。",
  "Dua cara untuk belajar": "两种学习方式",
  "Aktiviti dunia ialah simulasi interaktif untuk semakan reka bentuk. Nota, unit dan kemajuan sebenar kekal di JomBelajar dan memerlukan lesen aktif.": "世界活动是用于设计审阅的互动模拟。真实的笔记、单元和学习进度仍在 JomBelajar 中，并需要有效的许可证。",
  "Jawi Tadika →": "幼儿园爪夷文 →",
  "Cuba aliran UASA →": "试试UASA流程 →",
  "Permainan sebenar →": "正式游戏 →",
  "Mencari kandungan tahun ini…": "正在查找本年级内容…",
  "Kandungan belum dapat dimuat. Gunakan pautan JomBelajar.": "暂时无法加载内容，请使用 JomBelajar 链接。",
  "Aktiviti tidak tersedia": "活动不可用",
  "← Dunia Tahun {n}": "← {n}年级世界",
  "AKTIVITI CONTOH · DATA SIMULASI": "示例活动 · 模拟数据",
  "Buka unit sebenar →": "打开正式单元 →",
  "PENEMUAN {n}": "发现 {n}",
  "Cuba apa yang kamu pelajari": "试试你学到的内容",
  "Sentuh. Susun. Temui.": "触摸、排列、发现。",
  "Sentuh setiap bahagian tumbuhan, kemudian jalankan eksperimen air.": "触摸植物的每个部分，然后进行水的实验。",
  "Teroka peristiwa pada garis masa mengikut urutan.": "按顺序探索时间线上的事件。",
  "Sentuh kad untuk melihat respons maskot dan susunan baharu.": "点击卡片，看看吉祥物的反应和新的排列。",
  "{item} — bagus, teruskan meneroka!": "{item} — 很棒，继续探索！",
  "Teroka lagi →": "继续探索 →",
  "Susunan berubah. Mari cuba sekali lagi.": "排列变了，再试一次吧。",
  "KUIZ CONTOH": "示例测验",
  "Betul! Hebat usaha kamu!": "答对了！你很努力！",
  "Belum tepat. Cuba lagi, kami temankan.": "还不对，再试一次，我们陪着你。",
  "Betul! Kamu berjaya.": "答对了！你成功了。",
  "Belum tepat. Cuba pilihan lain.": "还不对，试试其他选项。",
  "Nota dan kuiz sebenar dalam JomBelajar →": "正式的笔记和测验在 JomBelajar 中 →",
  "SIMULASI REKA BENTUK · TIADA KREDIT DITOLAK": "设计模拟 · 不会扣除积分",
  "Meja persediaan UASA": "UASA准备台",
  "Tetapan → proses → kertas tersedia → pratonton.": "设置 → 处理 → 试卷就绪 → 预览。",
  "Jana kertas contoh": "生成示例试卷",
  "Menyediakan kertas contoh… {n}%": "正在准备示例试卷… {n}%",
  "SIMULASI · BUKAN KERTAS PEPERIKSAAN RASMI": "模拟 · 并非正式考试试卷",
  "Latihan contoh {subject} Tahun {year}": "{year}年级{subject}示例练习",
  "Nama: _____________________ Tarikh: ______________": "姓名：_____________________ 日期：______________",
  "Lihat jawapan": "查看答案",
  "Cetak contoh": "打印示例",
  "Buka penjana UASA sebenar →": "打开正式的UASA生成器 →",
  "Menyusun kertas contoh. Tunggu sehingga pratonton tersedia.": "正在整理示例试卷，请等待预览准备好。",
  "Kertas contoh sudah tersedia untuk dipratonton.": "示例试卷已可预览。",
  "DASHBOARD CONTOH · SEMUA REKOD DI BAWAH ADALAH SIMULASI": "示例仪表板 · 以下所有记录均为模拟",
  "Usaha dikongsi, ilmu bertambah.": "分享努力，知识增长。",
  "Pembeli awal yang layak boleh mempromosikan lesen baharu melalui referral.": "符合资格的早期购买者可以通过推荐来推广新的许可证。",
  "Dashboard contoh": "示例仪表板",
  "referral": "推荐",
  "jualan": "销售",
  "komisen": "佣金",
  "Paparan {tab} contoh dibuka.": "已打开示例{tab}视图。",
  "Pautan referral contoh": "示例推荐链接",
  "CONTOH-KOD-ANDA": "示例-您的代码",
  "Ini kod demonstrasi. Pautan sebenar hanya tersedia dalam akaun affiliate yang layak.": "这是演示代码。真实链接只会出现在符合资格的推广账户中。",
  "Kod contoh disalin": "示例代码已复制",
  "Salin kod contoh": "复制示例代码",
  "Rekod jualan simulasi": "模拟销售记录",
  "Rujukan": "编号",
  "Dalam tempoh tahanan": "保留期内",
  "Diluluskan — contoh": "已批准 — 示例",
  "Komisen contoh": "示例佣金",
  "JUALAN CONTOH": "示例销售",
  "KOMISEN SETIAP JUALAN*": "每笔销售佣金*",
  "TEMPOH TAHANAN": "保留期",
  "{n} hari": "{n}天",
  "*Contoh pembeli lesen RM{n}. Peraturan sebenar menggunakan harga lesen dan kelayakan akaun.": "*示例：购买 RM{n} 许可证的买家。实际规则以许可证价格和账户资格为准。",
  "Buka dashboard affiliate sebenar →": "打开正式的推广仪表板 →",
  "SEMAKAN ASET & AKSI": "素材与动作审阅",
  "Kenali Aiman dan Aina.": "认识 Aiman 和 Aina。",
  "Pilih aksi di bawah. Kami akan menghadap kamu selepas meneroka, dan duduk di kerusi bersama meja serta buku apabila membaca atau menulis.": "选择下面的动作。探索之后我们会面向你；阅读或书写时，我们会坐在椅子上，面前有桌子和书。",
  "Idle / bernafas": "待机 / 呼吸",
  "Berkelip": "眨眼",
  "Berjalan": "走路",
  "Berlari": "跑步",
  "Melambai": "挥手",
  "Menunjuk": "指向",
  "Melompat": "跳跃",
  "Duduk & membaca": "坐下阅读",
  "Menulis": "书写",
  "Meraikan": "庆祝",
  "Jawapan betul": "答对了",
  "Galakan": "鼓励",
  "Menoleh": "转头看",
  "Aksi: {name}": "动作：{name}",
  "Peta dunia →": "世界地图 →",
  "Aliran UASA →": "UASA流程 →",
  "Dashboard affiliate contoh →": "示例推广仪表板 →",
  "Hai! Kami Aiman dan Aina. Jom teroka bersama.": "你好！我们是 Aiman 和 Aina，一起去探索吧。",
  "Jom masuk portal Tahun {n}!": "一起进入{n}年级传送门吧！",
  "Dunia Tahun {n} dibuka. Pilih kawasan subjek di bawah.": "{n}年级世界已开启，请在下方选择科目区域。",
  "Peranti ini tidak dapat memaparkan WebGL. Gunakan pilihan tahun dan semua aktiviti di bawah.": "此设备无法显示 WebGL，请使用下方的年级选项和所有活动。",
  "Enjin 3D tidak dapat dimuat. Cuba semula; navigasi biasa masih tersedia.": "无法加载3D引擎，请重试；普通导航仍然可用。",
  "Semak pautan, jualan dan komisen dalam akaun kamu.": "请在你的账户中查看链接、销售和佣金。",
  "Pilih tetapan kertas. Pratonton hanya muncul apabila kertas tersedia.": "请选择试卷设置。试卷准备好后才会显示预览。",
  "Kami temankan. Ikut panduan pada borang di bawah.": "我们陪着你。请按照下方表格的提示操作。",
  "Pilih subjek dan mulakan penemuan baharu.": "选择科目，开始新的发现。",
  "Sedikit demi sedikit, kamu pasti boleh!": "一点一点来，你一定可以！",
  "DUNIA PEMBELAJARAN 3D": "3D学习世界",
  "PRATONTON STAGING": "测试环境预览",
  "Dunia 3D bersama Aiman dan Aina": "与 Aiman 和 Aina 一起的3D世界",
  "Enam pulau pembelajaran dan dua maskot 3D. Gunakan butang tahun di bawah untuk akses papan kekunci.": "六座学习岛屿和两个3D吉祥物。请使用下方的年级按钮以便键盘操作。",
  "Menyiapkan dunia dan dua maskot…": "正在准备世界和两个吉祥物…",
  "Cuba semula 3D": "重试3D",
  "Pilih dunia": "选择世界",
  "Sapa maskot": "和吉祥物打招呼",
  "Maskot melambai": "吉祥物挥手",
  "Hai! Pilih satu portal untuk mula.": "你好！选择一个传送门开始吧。",
  "Sambung animasi": "继续动画",
  "Jeda animasi": "暂停动画",
  "Menuju portal…": "正前往传送门…",
  "Sentuh portal bercahaya atau pilih dunia di bawah": "点击发光的传送门，或在下方选择世界",
  "Model {file} tidak dapat dimuat. Cuba semula paparan 3D.": "无法加载模型 {file}，请重试3D视图。",
  "Paparan 3D terhenti. Navigasi dan aktiviti masih boleh digunakan. Cuba muat semula paparan.": "3D画面已停止。导航和活动仍可使用，请尝试重新加载画面。",
  "Dunia 1–6": "世界 1–6",
  "PRATONTON DUNIA JOMCERDIK · BELAJAR SAMBIL MENEROKA": "JOMCERDIK 世界预览 · 边探索边学习",
  "Uji 13 aksi maskot →": "测试13个吉祥物动作 →",
  "Pautan lain": "其他链接",
  "Tadika": "幼儿园",
  "Jawi": "爪夷文",
  "Kira": "数数",
  "Harga & pembelian": "价格与购买",
  "Redeem": "兑换",
  "Kredit": "积分",
  "Refund": "退款",
  "Kertas sedang dijana. Tunggu status sebenar sebelum membuka pratonton.": "试卷正在生成。请等待实际状态后再打开预览。",
  "Kertas siap! Buka kertas yang tersedia dalam senarai.": "试卷已完成！请在列表中打开试卷。",
  "Cuba lagi. Kamu boleh belajar daripada jawapan tadi.": "再试一次。你可以从刚才的答案中学习。",
  "Betul! Hebat usaha kamu.": "答对了！你很努力。",
  "Cuba lagi, kamu boleh!": "再试一次，你可以的！",
  "Akaun saya": "我的账户",
  "Aktif": "已激活",
  "Belum aktif": "尚未激活",
  "Tetapkan kata laluan": "设置密码",
  "Tukar kata laluan": "更改密码",
  "Kata laluan baharu": "新密码",
  "Sahkan kata laluan": "确认密码",
  "Sekurang-kurangnya 8 aksara.": "至少 8 个字符。",
  "Kata laluan sekurang-kurangnya 8 aksara.": "密码至少需要 8 个字符。",
  "Kata laluan tidak sama.": "两次输入的密码不一致。",
  "Kata laluan disimpan. Lain kali anda boleh log masuk dengan emel dan kata laluan.": "密码已保存。下次可用邮箱和密码登录。",
  "Simpan": "保存",
  "Tetapkan kata laluan supaya lain kali anda boleh log masuk tanpa menunggu emel.": "设置密码后，下次登录无需等待邮件。",
  "Tetapkan sekarang": "立即设置",
  "Masukkan emel dan kata laluan anda.": "请输入邮箱和密码。",
  "Kami hantar pautan log masuk sekali guna ke emel anda. Guna ini kali pertama atau jika terlupa kata laluan.": "我们会向您的邮箱发送一次性登录链接。首次登录或忘记密码时使用。",
  "Kata laluan": "密码",
  "Kali pertama atau lupa kata laluan? Hantar pautan ke emel": "首次登录或忘记密码？发送链接到邮箱",
  "Log masuk dengan kata laluan": "使用密码登录",
  "Emel atau kata laluan salah. Belum ada kata laluan? Guna pautan emel.": "邮箱或密码错误。还没有密码？请使用邮件链接。",
  "Terlalu banyak cubaan salah. Cuba lagi dalam 15 minit atau guna pautan emel.": "错误次数过多。请 15 分钟后再试，或使用邮件链接。",
  "Masukkan emel anda. Kami hantar pautan untuk anda tetapkan kata laluan baharu.": "请输入您的邮箱。我们会发送链接供您设置新密码。",
  "Hantar pautan tetapan semula": "发送重置链接",
  "Lupa kata laluan?": "忘记密码？",
  "Kali pertama? Hantar pautan ke emel": "首次登录？发送链接到邮箱",
  "Semak emel anda. Klik pautan untuk log masuk, kemudian tetapkan kata laluan baharu. Pautan sah selama 15 minit.": "请查看邮箱。点击链接登录，然后设置新密码。链接 15 分钟内有效。",
  "Kertas belum lulus semakan kandungan atau tulisan. Kredit anda tidak ditolak.": "试卷尚未通过内容或文字检查，未扣除生成次数。",
  "Gambar belum berjaya dijana. Kertas belum disiapkan dan kredit anda tidak ditolak.": "插图生成未成功，试卷尚未完成，未扣除生成次数。",
  "Gambar kertas belum dapat dimuat turun. Sila cuba muat turun semula.": "暂时无法下载试卷插图，请重试下载。",
  "Tahun 1–6": "1–6年级",
  "Belajar dengan lebih seronok bersama JomCerdik": "与 JomCerdik 一起更有趣地学习",
  "Nota, audio, aktiviti, kuiz dan kertas UASA untuk Tadika hingga Tahun 6.": "从幼儿园到六年级的笔记、音频、活动、测验和 UASA 试卷。",
  "Akses pantas ke modul pembelajaran": "快速进入学习模块",
  "Kategori Tadika": "幼儿园类别",
  "Cari modul, subjek atau kategori…": "搜索模块、科目或类别…",
  "Cari": "搜索",
  "Berapa banyak?": "有多少？",
  "Apakah huruf pertama?": "第一个字母是什么？",
  "Pilih warna": "选择颜色",
  "Pilih bentuk": "选择形状",
  "Sentuh": "点一点",
  "Kategori tidak dijumpai.": "找不到该类别。",
  "Semua kategori": "所有类别",
  "Mula latihan": "开始练习",
  "Tekan gambar untuk dengar": "点图片即可收听",
  "Kira gambar dan tekan untuk dengar": "数一数图片，点一下来听",
  "Dengar lagi": "再听一次",
  "Adi, murid tadika": "阿迪，幼儿园学生",
  "Betul! Bagus!": "答对了！真棒！",
  "Dengar soalan": "听题目",
  "Gambar untuk dikira": "要数的图片",
  "Lihat keputusan": "查看结果",
  "Tahniah!": "恭喜！",
  "betul pada cubaan pertama": "第一次就答对",
  "Kategori pembelajaran": "学习类别",
  "Jana Kertas": "生成试卷",
  "Pilih tahun, subjek, format dan topik.": "选择年级、科目、格式和主题。",
  "Latihan Dalam Talian": "在线练习",
  "Pratonton, jawab dan semak jawapan terus.": "预览、作答并立即核对答案。",
  "Kertas Saya": "我的试卷",
  "Muat turun PDF kertas dan skema.": "下载试卷和答案PDF。",
  "Keputusan dan Laporan": "成绩与报告",
  "Markah, bintang dan kertas yang perlu diulang.": "分数、星星和需要重做的试卷。",
  "UASA lebih mudah, lebih teratur": "UASA 更简单、更有条理",
  "Bahagian UASA": "UASA 板块",
  "Kertas siap boleh dijawab dalam talian di bahagian Latihan Dalam Talian.": "完成的试卷可在“在线练习”中作答。",
  "Buka latihan": "打开练习",
  "Belum ada kertas siap. Jana kertas dahulu.": "还没有完成的试卷，请先生成。",
  "Belum ada keputusan. Selesaikan satu latihan dalam talian.": "还没有成绩，请完成一次在线练习。",
  "Purata markah": "平均分",
  "{n} latihan diselesaikan": "已完成 {n} 次练习",
  "Perlu diulang": "需要重做",
  "Lihat semakan": "查看核对",
  "Latihan dalam talian": "在线练习",
  "Rajah soalan ini ada dalam PDF kertas.": "此题的图在试卷PDF中。",
  "Pratonton kertas. {n} soalan objektif boleh dijawab dalam talian; soalan lain ada dalam PDF.": "试卷预览。{n} 道选择题可在线作答，其余在PDF中。",
  "Jawapan anda": "你的答案",
  "Pilih bahagian badan": "选择身体部位",
  "Bintang": "星星",
  "Pilih satu bahagian badan untuk bermula.": "选择一个身体部位开始。",
  "pada badan Adi.": "在阿迪的身体上。",
  "Kemajuan": "进度",
  "Baca suku kata dan perkataan.": "认读音节和词语。",
  "Main sambil belajar.": "边玩边学。",
  "Modul Pembelajaran": "学习模块",
  "Soalan": "问题",
  "Apakah nama bahagian ini?": "这个部位叫什么？",
  "Tekan untuk dengar sebutan": "点击听发音",
  "Ulang Audio": "重播",
  "Belajar · Bermain · Jadi Lebih Bijak": "学习 · 游戏 · 更聪明",
  "Hai, Adik!": "你好，小朋友！",
  "Teruskan belajar hari ini": "今天继续学习",
  "Kemajuan Pembelajaran": "学习进度",
  "{a} / {b} modul": "{a} / {b} 个模块",
  "Bintang Terkumpul": "已获星星",
  "Kenal huruf besar dan kecil dengan gambar.": "用图片认识大小写字母。",
  "Kira gambar dan pilih nombor yang betul.": "数一数图片，选出正确的数字。",
  "Padankan warna dengan benda di sekeliling.": "把颜色和身边的东西配对。",
  "Kenal bulat, segi tiga, segi empat dan lain-lain.": "认识圆形、三角形、四边形等。",
  "Sentuh bahagian badan dan dengar namanya.": "点一点身体部位，听它的名字。",
  "Kenal haiwan dan bunyinya.": "认识动物和它们的叫声。",
  "Kenal buah tempatan yang sedap.": "认识好吃的本地水果。",
  "Makanan dan minuman yang kita suka.": "我们喜爱的食物和饮料。",
  "Kenderaan di darat, laut dan udara.": "陆地、海上和空中的交通工具。",
  "Kenal matahari, awan, pokok dan alam sekeliling.": "认识太阳、云、树和大自然。",
  "Kenal pekerjaan dan tugas mereka.": "认识各种职业和他们的工作。",
  "Kenal perasaan: gembira, sedih, marah dan lain-lain.": "认识心情：开心、难过、生气等。",
  "Tambah profil anak supaya kemajuan setiap anak disimpan dan boleh dipantau.": "添加孩子的档案，每个孩子的学习进度都会保存并可查看。",
  "Siapa belajar hari ini?": "今天谁来学习？",
  "Urus anak": "管理孩子",
  "Anak": "孩子",
  "Sudah mencapai had bilangan anak untuk satu akaun.": "已达到每个账户可添加的孩子人数上限。",
  "Belum dipilih": "尚未选择",
  "Belum mula": "尚未开始",
  "Log masuk untuk menambah anak dan melihat perkembangan mereka.": "登录后可添加孩子并查看他们的进步。",
  "Padam {name}? Sejarah belajarnya disimpan tetapi tidak lagi dipaparkan.": "删除 {name}？学习记录会保留，但不再显示。",
  "Akaun ibu bapa": "家长账户",
  "Anak-anak saya": "我的孩子",
  "Tambah nama anak, pilih maskot, dan lihat perkembangan setiap seorang.": "添加孩子的名字，选择吉祥物，查看每个人的进步。",
  "Perempuan": "女孩",
  "Lelaki": "男孩",
  "{n} nota": "{n} 篇笔记",
  "{n} kuiz": "{n} 次测验",
  "Lihat perkembangan": "查看进度",
  "Sedang belajar": "正在学习",
  "Pilih": "选择",
  "Ubah": "修改",
  "Padam": "删除",
  "+ Tambah anak": "+ 添加孩子",
  "Sudah mencapai had {n} anak.": "已达到 {n} 个孩子的上限。",
  "Sila masukkan nama anak.": "请输入孩子的名字。",
  "Ubah maklumat anak": "修改孩子资料",
  "Tambah anak": "添加孩子",
  "Nama anak": "孩子的名字",
  "Pilih maskot": "选择吉祥物",
  "Tahap persekolahan": "学习阶段",
  "Semua anak": "所有孩子",
  "Nota dibaca": "已读笔记",
  "Kuiz diambil": "已做测验",
  "Purata markah kuiz": "测验平均分",
  "Permainan dimain": "玩过的游戏",
  "14 hari terakhir": "最近 14 天",
  "Aktiviti belajar 14 hari terakhir": "最近 14 天的学习活动",
  "Penguasaan mengikut subjek": "各科掌握程度",
  "Belum ada kuiz. Minta {name} cuba kuiz pertama.": "还没有测验。请让 {name} 试做第一次测验。",
  "Perlu diperbaiki": "需要加强",
  "Cadangan: bantu {name} mengulang kaji {subject} dahulu.": "建议：先帮助 {name} 复习{subject}。",
  "Kuiz terkini": "最近的测验",
  "Ruang melukis ada dalam PDF kertas.": "绘画空间在试卷PDF中。",
  "Pratonton kertas. {n} soalan boleh dijawab terus dalam talian (pilih A, B, C).": "试卷预览。{n}题可直接在线作答（选A、B、C）。",
  "{n} bahagian": "{n}个部分",
  "Soalan menulis panjang boleh ditaip, tetapi tidak digalakkan. Untuk latihan menulis, jana kertas UASA atau DSKP (PDF) dan jawab di atas kertas.": "较长的书写题可以打字作答，但不建议。若要练习书写，请生成UASA或DSKP试卷（PDF）并在纸上作答。",
  "Jawapan menulis panjang tidak digalakkan di sini. Lebih baik jana kertas UASA atau DSKP (PDF) untuk latihan bertulis.": "不建议在这里写长答案。书写练习最好生成UASA或DSKP试卷（PDF）。",
  "Tunjuk jawapan contoh": "显示参考答案",
  "Jawapan contoh": "参考答案",
  "Untuk soalan menulis panjang, jana kertas UASA atau DSKP (PDF).": "长书写题请生成UASA或DSKP试卷（PDF）。",
  "Gambar soalan ini ada dalam PDF kertas.": "本题的图片在试卷PDF中。",
  "Menyediakan pilihan jawapan…": "正在准备答案选项…",
  "Bayar dengan FPX / kad": "使用 FPX / 银行卡付款",
  "Terus ke internet banking anda. Disahkan secara automatik — tak perlu hantar resit.": "直接前往网上银行付款，自动确认，无需上传收据。",
  "Bayar sekarang (FPX / kad)": "立即付款（FPX / 银行卡）",
  "Menyemak bayaran…": "正在查询付款…",
  "Kami sedang mengesahkan bayaran anda dengan Stripe. Halaman ini dikemas kini sendiri — jangan tutup.": "我们正在与 Stripe 确认您的付款。本页会自动更新，请勿关闭。",
  "atau bayar dengan DuitNow QR di bawah": "或使用下方 DuitNow QR 付款",
  "Bayar guna DuitNow QR (manual, perlu hantar resit)": "使用 DuitNow QR 付款（手动，需上传收据）",
  "Masukkan emel anda. Kami hantar pautan pengesahan, kemudian anda tetapkan kata laluan dan terus ke pembayaran.": "输入您的电子邮件。我们会发送确认链接，然后您设置密码并直接前往付款。",
  "Hantar pautan pengesahan": "发送确认链接",
  "Semak emel anda dan klik pautan untuk teruskan ke pembayaran. Pautan sah selama 15 minit.": "请查看电子邮件并点击链接继续付款。链接 15 分钟内有效。",
  "Sudah ada akaun? Log masuk": "已有账户？登录",
  "Lesen anda sudah aktif": "您的许可证已激活",
  "Terima kasih! Semua modul boleh digunakan sekarang.": "谢谢！所有模块现在都可以使用。",
  "Belum nampak lesen? Muat semula halaman ini, atau hubungi kami dengan emel akaun anda.": "还没看到许可证？请刷新此页面，或使用您的账户电子邮件联系我们。",
  "Akaun: {email}": "账户：{email}",
  "Sekurang-kurangnya 8 aksara. Anda guna ini untuk log masuk lain kali.": "至少 8 个字符。下次登录时使用。",
  "Sebentar sahaja.": "请稍候。",
  "Tambah": "加法",
  "Tolak": "减法",
  "Campur": "混合",
  "Belon": "气球",
  "Eja": "拼写",
  "Padan": "配对",
  "Pecah Belon": "戳气球",
  "Tekan belon yang ada jawapan betul.": "点有正确答案的气球。",
  "Matematik: tambah dan tolak.": "数学：加和减。",
  "Asingkan Sains": "科学分类",
  "Pilih topik, kemudian jawab dengan gambar.": "选一个主题，然后看图回答。",
  "Sains: haiwan, tumbuhan dan pancaindera.": "科学：动物、植物和五官。",
  "Eja Perkataan": "拼单词",
  "Lihat gambar, kemudian susun huruf.": "看图片，然后排好字母。",
  "Susun huruf untuk eja perkataan.": "排字母拼出单词。",
  "Buka dua kad dan cari pasangan yang sama.": "翻开两张卡片，找出相同的一对。",
  "Cari pasangan yang sama.": "找出相同的一对。",
  "Huruf besar dan kecil": "大写和小写字母",
  "Gambar dan perkataan": "图片和单词",
  "Langkah: {n}": "步数：{n}",
  "Betul! Pandai!": "对了！真棒！",
  "Kuiz": "小测验",
  "Jeda": "暂停",
  "Organ": "器官",
  "Suhu": "温度",
  "Kedudukan": "位置",
  "Satu edaran": "绕行一周",
  "Makan lagi": "再吃一次",
  "Makan!": "吃！",
  "Zum keluar": "缩小",
  "Pilih makanan": "选择食物",
  "Perjalanan Makanan": "食物之旅",
  "Sistem Suria": "太阳系",
  "Sistem pencernaan manusia": "人体消化系统",
  "Pilih makanan, kemudian tekan Makan!": "选择食物，然后点“吃！”",
  "Ikut makanan masuk ke dalam badan. Tekan organ untuk zum.": "跟着食物进入身体。点击器官放大。",
  "Ikut makanan melalui sistem pencernaan. Tekan organ untuk zum.": "跟着食物走过消化系统。点击器官放大。",
  "Titik hijau ialah asid dalam perut.": "绿点是胃里的酸。",
  "Makanan yang tidak diperlukan oleh badan keluar sebagai najis.": "身体不需要的食物会变成粪便排出。",
  "Planet mengelilingi Matahari. Tekan planet untuk zum.": "行星绕着太阳转。点击行星放大。",
  "Planet beredar mengelilingi Matahari. Tekan planet untuk zum.": "行星绕太阳运行。点击行星放大。",
  "Semakin jauh planet dari Matahari, semakin lama masa untuk beredar satu kali.": "行星离太阳越远，绕行一周的时间越长。",
  "Seret untuk putar. Cubit untuk zum.": "拖动旋转，双指缩放。",
  "Fotosintesis": "光合作用",
  "Beri pokok air, CO₂ dan cahaya matahari. Lihat ia membesar.": "给树提供水、二氧化碳和阳光，看它长大。",
  "Main semula": "再玩一次",
  "Peranti ini tidak menyokong 3D. Baca penerangan dan cuba kuiz.": "此设备不支持 3D。请阅读说明并试做小测验。",
  "Baru": "新",
  "Padan Warna": "配对颜色",
  "Tarik garisan: padankan warna dengan namanya.": "画线：把颜色和名称配对。",
  "Besar dan Kecil": "大写和小写",
  "Tarik garisan: padankan huruf kecil dengan huruf besar.": "画线：把小写字母和大写字母配对。",
  "Padan Binatang": "配对动物",
  "Tarik garisan: sambung dua bahagian binatang.": "画线：把动物的两半连起来。",
  "Padan Pekerjaan": "配对职业",
  "Tarik garisan: padankan gambar dengan nama pekerjaan.": "画线：把图片和职业名称配对。",
  "Tarik dari kiri ke kanan, atau ketik kiri kemudian kanan.": "从左拖到右，或先点左边再点右边。",
  "Padan Kenderaan": "配对交通工具",
  "Tarik garisan: padankan gambar dengan nama kenderaan.": "画线：把图片和交通工具名称配对。",
  "Padan Buah": "配对水果",
  "Tarik garisan: padankan gambar dengan nama buah.": "画线：把图片和水果名称配对。",
  "Space Math": "Space Math",
  "Medan permainan angkasa": "太空游戏区",
  "Gerakkan kapal, kemudian tekan Tembak pada batu angkasa yang ada jawapan betul. Jika tembak yang salah, batu itu akan hentam kapal!": "移动飞船，然后对准带有正确答案的太空岩石按「发射」。如果打错了，那块岩石会撞上你的飞船！",
  "Gerakkan kapal dan tembak batu angkasa yang ada jawapan betul. Tahun 1–6.": "移动飞船并击中带有正确答案的太空岩石。一至六年级。",
  "Tembak": "发射",
  "Geser jari pada skrin untuk gerakkan kapal ke bawah batu angkasa yang betul, kemudian tekan Tembak.": "在屏幕上滑动手指，把飞船移到正确的太空岩石下方，然后按「发射」。",
  "Kart Kuiz": "问答卡丁车",
  "Pandu kart 3D bersama Harraz atau Hannah. Pilih lorong jawapan betul untuk boost!": "和 Harraz 或 Hannah 一起驾驶 3D 卡丁车。选对答案的车道就能加速!",
  "Matematik & Sains": "数学与科学",
  "Pilih pemandu": "选择车手",
  "Topik": "主题",
  "Peranti ini tidak menyokong grafik 3D untuk permainan ini.": "此设备不支持这个游戏的 3D 画面。",
  "Bersedia…": "准备…",
  "Tempat": "名次",
  "Medan permainan": "游戏区域",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong.": "点按左、中或右来换车道。",
  "Pandu kart bersama Harraz atau Hannah! Pilih lorong dengan jawapan betul untuk dapat boost. Jawapan salah akan buat kart berpusing.": "和 Harraz 或 Hannah 一起开卡丁车!选对答案的车道就能加速,答错卡丁车会打转。",
  "Jawapan": "答案",
  "TAMAT": "终点",
  "Lari Kuiz": "问答跑酷",
  "Lari 3D bersama Harraz atau Hannah. Lari di bawah jawapan betul dan lompat timbunan buku!": "和 Harraz 或 Hannah 一起 3D 跑酷。从正确答案下面跑过,跳过书堆!",
  "Lari bersama Harraz atau Hannah! Lari di bawah papan jawapan yang betul. Lompat atau tukar lorong untuk elak timbunan buku.": "和 Harraz 或 Hannah 一起跑!从正确答案的牌子下面跑过。跳起或换车道来避开书堆。",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat.": "点按左、中或右来换车道。向上滑动来跳。",
  "Lastik Kuiz": "问答弹弓",
  "Lastik bola ke kotak jawapan yang betul bersama Harraz atau Hannah!": "和 Harraz 或 Hannah 一起,用弹弓把球射向正确答案的箱子!",
  "Bantu Harraz atau Hannah melastik! Tarik ke belakang, bidik dan lepaskan untuk pecahkan kotak dengan jawapan betul.": "帮 Harraz 或 Hannah 打弹弓!往后拉、瞄准、放手,打破正确答案的箱子。",
  "Tarik ke belakang, bidik, kemudian lepaskan.": "往后拉,瞄准,然后放手。",
  "Cuba lagi!": "再试一次!",
  "Terbang Kuiz": "问答飞行",
  "Terbang dengan beg jet melalui gelang jawapan betul bersama Harraz atau Hannah!": "和 Harraz 或 Hannah 一起背着喷气背包,飞过正确答案的圆环!",
  "Terbang dengan beg jet bersama Harraz atau Hannah! Terbang melalui gelang dengan jawapan betul dan kutip bintang.": "和 Harraz 或 Hannah 一起背着喷气背包飞行!飞过正确答案的圆环,收集星星。",
  "Sentuh atas, tengah atau bawah untuk naik atau turun.": "点按上、中或下来上升或下降。",
  "Dino Kejar": "恐龙追追",
  "Jadi Dino dan kejar Harraz dan Hannah di padang pasir! Dengar soalan, lari di bawah jawapan yang betul untuk mendekati mereka. Lompat kaktus dan elak burung.": "化身恐龙，在沙漠里追赶 Harraz 和 Hannah！听题目，从正确答案下面跑过就能追近他们。跳过仙人掌，避开飞鸟。",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat kaktus.": "点左、中或右换跑道。向上滑动跳过仙人掌。",
  "Jarak": "距离",
  "Kejar!": "追！",
  "Dapat!": "抓到了！",
  "Hampir dapat!": "差一点！",
  "Jadi Dino 3D dan kejar Harraz dan Hannah. Lari di bawah jawapan betul, lompat kaktus!": "化身3D恐龙追赶 Harraz 和 Hannah。从正确答案下面跑过，跳过仙人掌！",
  "BM & BI": "马来文与英文",
  "Jetski Kuiz": "摩托艇问答",
  "Tunggang jetski bersama Harraz atau Hannah di sungai bandar! Lalu gelang jawapan yang betul untuk nitro. Elak pelampung dan bot, lompat kayu balak.": "和 Harraz 或 Hannah 一起在城市河上骑摩托艇！穿过正确答案的圆环获得氮气加速。避开浮标和船只，跳过浮木。",
  "Tunggang jetski 3D di sungai bandar. Lalu gelang jawapan betul untuk nitro, elak bot!": "在城市河上骑3D摩托艇。穿过正确答案的圆环获得氮气加速，避开船只！",
  "Laju": "速度",
  "km/j": "公里/时",
  "Nitro!": "氮气加速！",
};
